import React from "react";
import { Link } from "react-router-dom";
import { FaTrash, FaEllipsisV, FaEnvelope } from "react-icons/fa";
import { useModifyProdContext } from '../context/modifyprod_context';
import { useState, useRef, useEffect } from "react";
import { useProfFilterContext } from "../context/prof_filter_context";

const ProfessionalRow = ({
  uid,
  name,
  contact_person,
  email,
  plan,
  joined,
  status,
}) => {
  
  const { deleteProduct } = useModifyProdContext();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const { reloadData } = useProfFilterContext();
  const optionsRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDelete = async() => {
    try {
      await deleteProduct(uid, plan);
      reloadData();
      setShowConfirm(false);
      setShowOptions(false);
    } catch(err) {
      console.error('delete failed:', err);
    }
  };

  const handleResendInvitation = async() => {
    try {
      // Add your resend invitation logic here
      // await resendInvitation(uid, email);
      console.log('Resending invitation to:', email);
      setShowOptions(false);
      // You can add a success notification here
    } catch(err) {
      console.error('Resend invitation failed:', err);
    }
  };

  return (
    <>
      <tr key={uid}>
        <td>{name}</td>
        <td>{contact_person}</td>
        <td>{email}</td>
        <td>{plan}</td>
        <td>
          <Link key={uid} to={`/prodedit/${uid}`} className="btn-large">
            Edit
          </Link>
        </td>
        <td className="options-cell" ref={optionsRef}>
          <FaEllipsisV
            size={18}
            color="#333"
            style={{ cursor: "pointer" }}
            onClick={() => setShowOptions(!showOptions)}
          />
          
          {showOptions && (
            <div className="options-dropdown">
              <div 
                className="option-item"
                onClick={() => {
                  setShowConfirm(true);
                  setShowOptions(false);
                }}
              >
                <FaTrash size={14} color="red" />
                <span>Delete</span>
              </div>
              <div 
                className="option-item"
                onClick={handleResendInvitation}
              >
                <FaEnvelope size={14} color="#007bff" />
                <span>Resend Invitation</span>
              </div>
            </div>
          )}
        </td>
      </tr>
      
      {showConfirm && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this professional?</p>
            <div className="popup-actions">
              <button className="btn-yes" onClick={handleDelete}>
                Yes
              </button>
              <button className="btn-cancel" onClick={() => setShowConfirm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfessionalRow;